import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Screen from 'screens/routes';
import reportWebVitals from './reportWebVitals';

// Set document title based on environment
const appEnv = import.meta.env.VITE_APP_ENV;
document.title = appEnv
  ? `PlayBook Fusion CMS - ${appEnv}`
  : 'PlayBook Fusion CMS';

ReactDOM.render(
  <React.StrictMode>
    <Screen />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
